/**
 * #1091 (F3, K6) — rótulo do `resource_type` da linha da fatura.
 *
 * Espelho dos valores de `_RESOURCE_TYPE_BY_REFERENCE` (e dos gravados direto) em
 * `backend/app/services/invoice_service.py` — pinado por `test/resourceTypeLabels.test.ts`,
 * que lê o backend: um tipo novo lá sem rótulo aqui reprova.
 */
export const RESOURCE_TYPE_LABELS: Readonly<Record<string, string>> = {
  vm: 'Máquina virtual',
  block_storage: 'Volume',
  backup: 'Backup',
  snapshot: 'Snapshot',
  resource_block: 'Contrato de bloco',
  voucher: 'Voucher',
  public_ip: 'IPv4 público',
  adjustment: 'Ajuste',
  subscription: 'Assinatura',
  consumption: 'Consumo',
}

/** Rótulo do tipo; sem tipo é "—", e tipo desconhecido aparece como veio (nunca some). */
export function rotuloDoTipoDeRecurso(tipo: string | null | undefined): string {
  if (!tipo) return '—'
  return RESOURCE_TYPE_LABELS[tipo] ?? tipo
}
